import React, { useState } from 'react';

import { Box, Grid, TextField, Typography } from '@material-ui/core';

import FloatingButton from '../../../../components/FloatingButton';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const OtherMaterialDamage = () => {
  const { nextStep, sinister_body, updateSinisterBody } =
    useSinisterDataContext();
  const [description, setDescription] = useState(
    sinister_body.description || ''
  );

  const callNextStep = () => {
    updateSinisterBody({ description });
    nextStep();
  };

  return (
    <>
      <Grid container>
        <Grid container item lg={12}>
          <Box my={3}>
            <Typography variant="h6" color="textPrimary">
              Otros daños materiales a terceros
            </Typography>
          </Box>
        </Grid>
        <Grid container justify="center" xs={12}>
          <Grid xs={12}>
            <TextField
              id="outlined-multiline-static"
              multiline
              fullWidth
              rows={8}
              placeholder="Completá si se produjeron daños materiales a terceros"
              variant="outlined"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
              error={description.length > 1333}
              helperText={
                description.length > 1333 &&
                'La descripción no debería superar los 1333 caracteres'
              }
            />
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item xs={12} sm={6}>
            <FloatingButton onClick={callNextStep}>Continuar</FloatingButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default OtherMaterialDamage;
